module.exports = __webpack_public_path__ + "static/img/yinger.597aedf1.png";